import { securedAxios } from "../lib/axios";
export default {
  namespaced: true,
  actions: {
    async boletos(context, { payload }) {
      try {
        const response = await securedAxios.post(
          `/ordem/email-boleto`,
          payload
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async medicaoCliente(context, { payload }) {
      try {
        const response = await securedAxios.post(
          `/ordem/email-medicao-cliente`,
          payload
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async faturaCancelada(context, { payload }) {
      try {
        const response = await securedAxios.post(
          `/ordem/email-fatura-cancelada`,
          payload
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async pacoteDocumentos(context,  {id_pacote, emails}) {
      try {
        const response = await securedAxios.post(
          `/documentos/pacotes/${id_pacote}/enviar-email`,
          emails
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
